import { IEndpointReponseProps } from "../../types";

// const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;
const baseURL =
  "https://aisewave-app.icyground-9e9982ba.westus2.azurecontainerapps.io/api/v1";

export const DashboardEndpoints = {
  GetCheckServerHealth: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/health`,
      method: "GET",
    };
  },

  /* 
    AUTHENTICATION ENDPOINTS
  */
  GetLogin: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/auth/login/`,
      method: "POST",
    };
  },
  GetRegister: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/auth/register/`,
      method: "POST",
    };
  },
  GetSendForgotPasswordEmail: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/auth/forget-password/`,
      method: "POST",
    };
  },
  GetResendForgotPasswordEmail: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/auth/forget-password/resend-otp/`,
      method: "POST",
    };
  },
  GetVerifyForgotPassword: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/auth/forget-password/confirm/`,
      method: "POST",
    };
  },
  GetUserProfile: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/user/profile/`,
      method: "GET",
    };
  },
  GetSetOnboardingDetails: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/onboarding/details/`,
      method: "POST",
    };
  },
  GetUpdatePassword: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/user/set-password/`,
      method: "POST",
    };
  },
  /* 
    ORGANIZATION ENDPOINTS
  */
  GetAllOrganizations: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/all/`,
      method: "GET",
    };
  },
  CreateOrganization: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/create/`,
      method: "POST",
    };
  },
  GetSingleOrganization: (organizationID: number): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/${organizationID}/detail/`,
      method: "GET",
    };
  },
  GetUpdateOrganization: (organizationID: number): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/update/${organizationID}/`,
      method: "PUT",
    };
  },
  GetUpdateOrganizationSlug: (
    organizationID: number
  ): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/slug/${organizationID}/`,
      method: "POST",
    };
  },
  GetSetOrganizationTheme: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/theme/edit/`,
      method: "PUT",
    };
  },
  GetGetOrganizationTheme: (organizationID: number): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/theme/?organization_id=${organizationID}`,
      method: "GET",
    };
  },
  GetSetOrganizationWebsite: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/set-website/`,
      method: "POST",
    };
  },
  GetSetOrganizationHomepageJSON: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/organization/theme/style/`,
      method: "POST",
    };
  },

  /* 
    EVENT ENDPOINTS
  */
  GetAllEvents: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/event/all/`,
      method: "GET",
    };
  },
  GetCreateEvent: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/events/create/`,
      method: "POST",
    };
  },
  GetUpdateEvent: (eventID: number): IEndpointReponseProps => {
    return {
      route: `${baseURL}/events/edit/${eventID}/`,
      method: "PUT",
    };
  },
  GetUserEvents: (): IEndpointReponseProps => {
    return {
      route: `${baseURL}/events/user/`,
      method: "GET",
    };
  },
  GetOrganizationEvents: (organizationID: number): IEndpointReponseProps => {
    return {
      route: `${baseURL}/events/organization/?id=${organizationID}`,
      method: "GET",
    };
  },
  GetSingleEvent: (eventID: number): IEndpointReponseProps => {
    return {
      route: `${baseURL}/events/${eventID}/detail/`,
      method: "GET",
    };
  },

  /* 
    EVENT TICKETS ENDPOINTS
  */
  GetEventTicketUsingTicketID: (ticketID: number): IEndpointReponseProps => {
    return {
      route: `${baseURL}/events/tickets/${ticketID}/get/`,
      method: "GET",
    };
  },
  GetAddTicketToEvent: (eventID: number): IEndpointReponseProps => {
    return {
      route: `${baseURL}/events/${eventID}/tickets/add/`,
      method: "POST",
    };
  },
  GetUpdateTicketInEvent: (ticketID: number): IEndpointReponseProps => {
    return {
      route: `${baseURL}/events/tickets/${ticketID}/edit/`,
      method: "POST",
    };
  },
  GetDeleteTicketFromEvent: (ticketID: number): IEndpointReponseProps => {
    return {
      route: `${baseURL}/events/tickets/${ticketID}/delete/`,
      method: "DELETE",
    };
  },
};
